import React from 'react'

import { H4 } from '@frame/ui-primitives/h4'

type Props = {
  children: string
}

export function Name({ children }: Props) {
  return (
    <H4 className="block max-w-[calc(100%-48px)] overflow-hidden truncate text-ellipsis text-moss-700">{children}</H4>
  )
}
